/**
 * Query pagination for "View More" button
 *
 * Initializes AJAX-based pagination for query blocks with "View More" buttons.
 * Fetches additional posts and appends them to the existing list when the button is clicked.
 *
 * @since 1.0.0
 */
export function initQueryPagination() {
	document.addEventListener('click', function (event) {
		const trigger = event.target.closest('.view-more-query');

		if (!trigger) {
			return;
		}

		event.preventDefault();

		const queryBlock = trigger.closest('.wp-block-query');
		const ajaxData = window.pacejax || {};

		if (!queryBlock || !ajaxData.ajax_url || !queryBlock.dataset.attrs) {
			return;
		}

		const currentPage = Number.parseInt(queryBlock.dataset.paged || '1', 10);
		const requestPage = Number.isNaN(currentPage) || currentPage < 1 ? 1 : currentPage;

		const requestData = new FormData();
		requestData.append(
			'action',
			ajaxData.query_pagination_action || 'query_render_more_pagination'
		);
		requestData.append('nonce', ajaxData.query_pagination_nonce || '');
		requestData.append('attrs', queryBlock.dataset.attrs);
		requestData.append('paged', String(requestPage));

		trigger.setAttribute('aria-disabled', 'true');

		fetch(ajaxData.ajax_url, {
			method: 'POST',
			credentials: 'same-origin',
			body: requestData,
		})
			.then(function (response) {
				if (!response.ok) {
					throw new Error('Query pagination request failed.');
				}

				return response.text();
			})
			.then(function (html) {
				// eslint-disable-next-line no-undef
				const parser = new DOMParser();
				const documentFragment = parser.parseFromString(html, 'text/html');
				const responseQueryBlock = documentFragment.querySelector('.wp-block-query');

				if (!responseQueryBlock) {
					return;
				}

				const currentPostList = queryBlock.querySelector('.wp-block-post-template');
				const responsePostList =
					responseQueryBlock.querySelector('.wp-block-post-template');

				if (currentPostList && responsePostList) {
					Array.from(responsePostList.children).forEach(function (item) {
						currentPostList.appendChild(item.cloneNode(true));
					});
				}

				queryBlock.dataset.paged = String(requestPage + 1);

				const currentButtonWrapper = trigger.closest('.wp-block-buttons');
				const responseButtonWrapper = responseQueryBlock.querySelector('.wp-block-buttons');

				if (currentButtonWrapper) {
					if (responseButtonWrapper) {
						currentButtonWrapper.replaceWith(responseButtonWrapper);
					} else {
						currentButtonWrapper.remove();
					}
				}
			})
			.catch(function () {
				trigger.setAttribute('aria-disabled', 'false');
			});
	});
}
